import optimizeImage from '~/utilities/optimizeImage';
import type { SelectedWhyBuyMedia } from './selectWhyBuyMedia';

type WhyBuyMediaProps = {
  imageUrl?: string;
  videoUrl?: string;
};

type Options = {
  height: number;
};

export default function getWhyBuyMediaProps(
  media: SelectedWhyBuyMedia | undefined,
  { height }: Options
): WhyBuyMediaProps {
  if (!media) {
    return {};
  }

  if (media.mimeType.startsWith('video/')) {
    return { videoUrl: media.url };
  }

  const imageUrl = optimizeImage(media.url, {
    format: 'auto',
    height,
    optimize: 'high',
    quality: 90
  });

  return imageUrl ? { imageUrl } : {};
}
